import React from 'react';
import { Heart, Send } from 'lucide-react';

const LOGO_URL = "/assets/logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-cardBg py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid sm:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Shunya Gatha" className="w-10 h-10 rounded-full ring-1 ring-neonBlue/30" />
              <div>
                <h3 className="font-heading font-bold text-white text-lg">Shunya Gatha</h3>
                <span className="text-xs text-neonGold/60 font-hindi">शून्य गाथा</span>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Daily audio episode-based stories. Epic storytelling delivered to your Telegram every day.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm tracking-wider uppercase">Quick Links</h4>
            <div className="space-y-2">
              <a href="#home" className="block text-gray-500 text-sm hover:text-neonBlue transition-colors">Home</a>
              <a href="#episodes" className="block text-gray-500 text-sm hover:text-neonBlue transition-colors">Stories</a>
              <a href="#sneak-peeks" className="block text-gray-500 text-sm hover:text-neonBlue transition-colors">Sneak Peeks</a>
              <a href="#buy" className="block text-gray-500 text-sm hover:text-neonBlue transition-colors">Buy Episodes</a>
              <a href="#contact" className="block text-gray-500 text-sm hover:text-neonBlue transition-colors">Contact</a>
            </div>
          </div>

          {/* Telegram */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm tracking-wider uppercase">Telegram</h4>
            <div className="space-y-2">
              <a href="https://t.me/the_warrior_SunyaGatha" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-500 text-sm hover:text-[#2AABEE] transition-colors">
                <Send size={12} /> Main Channel
              </a>
              <a href="https://t.me/Sunya_Gatha" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-500 text-sm hover:text-[#2AABEE] transition-colors">
                <Send size={12} /> Updates Channel
              </a>
              <a href="https://t.me/Ak0nikk" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-500 text-sm hover:text-[#2AABEE] transition-colors">
                <Send size={12} /> Buy Episodes
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} Shunya Gatha. All rights reserved.
          </p>
          <p className="flex items-center gap-1 text-gray-600 text-xs">
            Made with <Heart size={12} className="text-pink-500" /> for Story Lovers
          </p>
        </div>
      </div>
    </footer>
  );
}
